<template>
  <div>
    <v-text-field
      @click="chooseFile()"
      v-model="fileName"
      clearable
      readonly
      :box="inputBoxStyle"
      @click:clear="deleteFile"
      :class="getFieldClass(fieldConfig)"
      :label="$t(fieldConfig.label)"
      :append-icon="icon"
      @click:append="chooseFile"
      :error-messages="error"
      v-bind="$attrs"
    ></v-text-field>

    <input
      type="file"
      id="file"
      ref="fileInput"
      v-on:change="handleFileUpload()"
      style="display:none"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    icon: {
      type: [String],
      default: 'mdi-folder-open',
    },
    value: {
      type: File,
    },
    fieldConfig: {
      type: Object,
      default: () => {
        return {
          class: 'mx-2',
          name: 'file',
          label: 'File',
          instructions: 'Add a file',
          type: 'file',
          attrs: { xs6: true },
        };
      },
    },
    label: {
      type: String,
    },
    error: {
      type: String,
    },
    inputBoxStyle: {
      type: Boolean,
      default: false,
    },
  },
  /*
          Defines the data used by the component
        */
  data() {
    return {
      file: '',
      documentData: {
        month: '',
        type: '',
        file: null,
        status: 'uncontabilized',
      },
    };
  },
  computed: {
    fileName() {
      return this.file ? this.file.name : '';
    },
  },

  methods: {
    deleteFile() {
      this.file = null;
    },

    chooseFile() {
      this.$refs.fileInput.click();
    },

    /*
              Handles a change on the file upload
            */
    handleFileUpload() {
      this.file = this.$refs.fileInput.files[0];
    },
    getFieldClass() {
      return this.fieldConfig['class'] ? this.fieldConfig['class'] : '';
    },
  },
  watch: {
    value: function(val) {
      this.file = val;
    },
    file: function(val, oldVal) {
      this.$emit('input', this.file);
    },
  },
};
</script>
